import { takeLatest, call, put } from "redux-saga/effects";
import axiosInstance, { authRequest, scriptsRequest } from "services/httpService";
import { successHandler } from "helpers/httpHelpers";
import * as types from "./types";
import safeSaga from "helpers/safeSaga";
import { ADMIN_APP_AUTHORIZED_KEY, ADMIN_ONLY_MESSAGE, isAdminUser } from "utils/adminAuth";
import { errorToast } from "utils/hooks";

function* handleAdminSession(response, successActionType: string, errorActionType: string) {
  let isAuthorized = isAdminUser(response.data?.data);

  if (!isAuthorized) {
    try {
      yield call([axiosInstance, "get"], scriptsRequest.SCRIPTS_ADMIN);
      isAuthorized = true;
    } catch (_err) {
      isAuthorized = false;
    }
  }

  if (!isAuthorized) {
    localStorage.removeItem("userInfo");

    try {
      yield call([axiosInstance, "get"], authRequest.LOGOUT);
    } catch (_err) {
      // The login boundary still rejects non-admins even if logout cleanup fails.
    }

    errorToast(ADMIN_ONLY_MESSAGE);
    yield put({
      type: errorActionType,
      payload: {
        errors: {
          message: ADMIN_ONLY_MESSAGE,
        },
      },
    });
    return;
  }

  const adminResponse = {
    ...response,
    data: {
      ...response.data,
      data: {
        ...response.data?.data,
        [ADMIN_APP_AUTHORIZED_KEY]: true,
      },
    },
  };

  localStorage.setItem("userInfo", JSON.stringify(adminResponse.data));

  yield successHandler(adminResponse, successActionType);
}

function* signInUser({ payload }: Record<string, any>) {
  yield call([axiosInstance, "post"], authRequest.LOGIN, payload);
  const response = yield call([axiosInstance, "get"], authRequest.ME);

  yield handleAdminSession(response, types.LOGIN.success, types.LOGIN.error);
}
function* logoutUser() {
  const response = yield call([axiosInstance, "get"], authRequest.LOGOUT);

  localStorage.removeItem("userInfo");

  yield successHandler(response, types.LOGOUT.success);
}

export default function* authSaga(): unknown {
  yield takeLatest(types.LOGIN.request, safeSaga(signInUser, types.LOGIN.error));
  yield takeLatest(types.LOGOUT.request, safeSaga(logoutUser, types.LOGOUT.error));
}
